import './bookSummary.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactMarkdown from 'react-markdown';
import { books } from '../../data/books';
import { Link } from 'react-router-dom';

function BookSummary({ book }) {
  if (!book) {
    return <p>Book not found.</p>;
  }

  const {
    title,
    author,
    dateRead,
    cover,
    categories = [],
    contentSections = [],
    slug,
  } = book;

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert('Link copied to clipboard!');
  };

  const renderContentItem = (item, index) => {
    if (item.type === 'markdown') {
      return <ReactMarkdown key={index}>{item.value}</ReactMarkdown>;
    }
    return null;
  };

  // Filter out current book and randomly select up to 3 others
  const recommendedBooks = books
    .filter((b) => b.slug !== slug)
    .sort(() => 0.5 - Math.random())
    .slice(0, 3);

  return (
    <div className="book-summary-page">
      {/* Hero Section */}
      <div className="book-hero-clean">
        <div className="book-hero-layout">
          <div className="book-hero-text">
            <h1 className="book-title-clean font-main">
              {title} – What I Learned
            </h1>
            <p className="book-meta-clean">
              by {author} / {dateRead}
            </p>
            <div className="book-hero-tags">
              {categories.map((cat) => (
                <span key={cat} className={`tag tag-${cat.toLowerCase()}`}>
                  {cat}
                </span>
              ))}
            </div>
            <div className="share-buttons">
              {book.mediumLink && (
                <button
                  onClick={() => window.open(book.mediumLink, '_blank')}
                  title="View on Medium"
                >
                  <i className="fa-brands fa-medium"></i>
                </button>
              )}
              <button onClick={copyLink} title="Copy Link">
                <i className="fa-solid fa-link"></i>
              </button>
            </div>
          </div>
          <div className="book-hero-image">
            <img src={cover} alt={`${title} cover`} />
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="book-summary-content">
        <aside className="summary-toc">
          <nav>
            <ul>
              {contentSections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.title}</a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
        <div className="summary-article">
          {contentSections.map(({ id, title, content }) => (
            <section key={id} id={id}>
              <h2>{title}</h2>
              {content.map((item, i) => renderContentItem(item, i))}
            </section>
          ))}
        </div>
      </div>

      {/* Read Next Section */}
      <div className="read-next-section">
        <div className="read-next-header">
          <h2 className="font-main">Read Next</h2>
          <Link to="/library" className="explore-all-btn">
            Explore All →
          </Link>
        </div>
        <div className="book-card-grid">
          {recommendedBooks.map((book) => (
            <div className="book-card" key={book.slug}>
              <img src={book.cover} alt={book.title} />
              <div className="book-card-text">
                <h3>{book.title}</h3>
                <p className="book-author">{book.author}</p>
                <span className="book-tag">{book.category}</span>
                <Link to={`/library/${book.slug}`} className="read-more-link">
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BookSummary;